import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import {
    JiraOverlayTemplate,
    LayoutVersion
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { WelcomeBackHeading } from "../../../components";

export const LoggedInJiraFreeManagedUser = () => {
    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    const version = modalVisualUpdates ? LayoutVersion.V3 : LayoutVersion.V1;

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm" version={version}>
                <div css={containerCss}>
                    <h1 css={headerCss}>
                        <WelcomeBackHeading />
                    </h1>
                    <p
                        css={[
                            subHeaderCss,
                            modalVisualUpdates && subHeaderBlackCss
                        ]}
                    >
                        <FormattedMessage
                            id="JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff"
                            defaultMessage="Pick up where you left off in Jira."
                        />
                    </p>
                    <SiteActivation />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    marginBlockStart: 4,
    marginBlockEnd: 16,
    textAlign: "center"
});

const subHeaderBlackCss = css({
    color: token("color.text")
});
